import {
  ProfileOption,
  UserProfileInput,
} from '@coverright/data-access/types/enrollment';
import { useLogEvent } from '@coverright/shared/analytics';
import {
  covertDateToSeverFormat,
  getCId,
  getMedigapQuoteId,
  getPdpQuoteId,
  getQuoteId,
  getStoredUser,
  setStoredUser,
  getTrackingParams,
  getVid,
  getUId,
  getClientId,
} from '@coverright/utils';
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';
import { useSaveUserProfileMutation } from '@coverright/data-access/enrollment';
import posthog from 'posthog-js';

export function useCreateProfile() {
  const [saveProfile] = useSaveUserProfileMutation({
    client: enrollmentApolloClient,
  });
  const logEvent = useLogEvent();

  const save = async (data: Partial<UserProfileInput>) => {
    const {
      cId: trackingCId,
      uId: trackingUId,
      utmSource,
      utmCampaign,
      utmMedium,
      utmTerm,
      utmContent,
      utmBrand,
      gclid,
      msclkid,
      fbclid,
      gbraid,
      wbraid,
      oppref,
    } = getTrackingParams();

    const res = await saveProfile({
      variables: {
        data: {
          options: [ProfileOption.RegisterUser],
          medigapQuoteId: getMedigapQuoteId(),
          pdpQuoteId: getPdpQuoteId(),
          quoteId: getQuoteId(),
          cId: getVid() || trackingCId || getUId(),
          uId: getUId() || trackingUId,
          utmSource,
          utmCampaign,
          utmMedium,
          utmTerm,
          utmContent,
          utmBrand,
          gclid,
          msclkid,
          fbclid,
          gbraid,
          wbraid,
          oppref,
          profileId: getStoredUser()?.profileId,
          clientId: getClientId() || getStoredUser()?.clientId,
          gender: getStoredUser()?.gender,
          birthDate: covertDateToSeverFormat(getStoredUser()?.birthDate),
          tobacco:
            typeof getStoredUser()?.tobacco !== 'undefined'
              ? getStoredUser()?.tobacco === 'true'
              : undefined,
          zip: getStoredUser()?.zip,
          countyName: getStoredUser()?.countyName,
          state: getStoredUser()?.state,
          enrolled: getStoredUser()?.enrolled,
          ...data,
        },
      },
    });

    const userProfile = res.data?.saveUserProfile;

    (window as any).gtm_profile_id = userProfile?.profileId;

    logEvent('profile-saved', { profile_id: userProfile?.profileId });

    if (posthog && posthog.get_distinct_id()) {
      posthog.identify(userProfile?.clientId, {
        email: getStoredUser()?.email,
        name: getStoredUser()?.firstName + ' ' + getStoredUser()?.lastName,
        profileId: userProfile?.profileId,
      });
    }

    setStoredUser({ ...getStoredUser(), profileId: userProfile?.profileId, clientId: userProfile?.clientId });

    return userProfile;
  };

  return save;
}
